import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { PRODUCT_IMAGE } from '../../data/content';
const perks = ['One-time payment', 'Instant access', 'Lifetime access', '7-day guarantee'];
export function FinalCtaSection() {
  return <section className="bg-navy-900 py-14 text-white sm:py-20" aria-labelledby="final-title" data-id="element-131" data-mp="2dlprm4kogocx">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-132" data-mp="2rgrtmgmeltkg">
        <p className="mx-auto max-w-2xl text-balance text-center text-[15px] font-semibold leading-relaxed text-navy-100 sm:text-lg" data-id="element-133" data-mp="2mj9vzmdu70rr">
          Your next clinical decision is coming sooner than you think. The difference is that this
          time, you’ll have a clearer structure to help you move forward with greater speed,
          confidence, and consistency.
        </p>

        <img src={PRODUCT_IMAGE} alt="Complete Clinical Decision System for Diabetes package" className="mx-auto mt-8 w-full max-w-[340px]" loading="lazy" data-id="element-134" data-mp="368tqrsx3a8gs" />

        <h2 id="final-title" className="mt-6 text-balance text-center text-2xl font-black leading-tight tracking-tight sm:text-3xl" data-id="element-135" data-mp="2637n1cbeu3bp">
          The complete Clinical Decision System for Diabetes
        </h2>

        <div className="mt-7 rounded-3xl border border-white/10 bg-white/5 p-5 sm:p-7" data-id="element-136" data-mp="2fy9b04ty8zcp">
          <p className="text-center text-[11px] font-black uppercase tracking-[0.16em] text-clinic-300 sm:text-xs" data-id="element-137" data-mp="2kz6rmczb9lc3">
            Special launch price
          </p>
          <div className="mt-3 flex items-end justify-center gap-3" data-id="element-138" data-mp="2trh4k21lc4x1">
            <span className="text-xl font-bold text-navy-300 line-through sm:text-2xl" data-id="element-139" data-mp="2yqtz78ypega6">$237</span>
            <span className="text-5xl font-black leading-none tracking-tight text-white sm:text-6xl" data-id="element-140" data-mp="33pwwu8cctk84">
              $27
            </span>
            <span className="pb-1 text-sm font-black text-clinic-300" data-id="element-141" data-mp="38q2q1sy9vesb">USD</span>
          </div>

          <ul className="mt-5 grid grid-cols-2 gap-2" data-id="element-142" data-mp="2j1xboyrve4g4">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2" data-id="element-143" data-mp="2e2kf3mb75j0c">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-clinic-300" aria-hidden="true" data-id="element-144" data-mp="2sqoxsqa91uj4" />
                <span className="text-[12.5px] font-semibold text-navy-100 sm:text-sm" data-id="element-145" data-mp="2nzyvxn1189t6">{perk}</span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-146" data-mp="31q29lpluiv70">
            <CTAButton subtext="Currency conversion is automatic at checkout" data-id="element-147" data-mp="31tgcr02c38fi">
              ✅ Yes, I want access to the system now
            </CTAButton>
          </div>

          <div className="mt-5" data-id="element-148" data-mp="3bp19aiomvghv">
            <Countdown label="Launch price ends in" data-id="element-149" data-mp="3bn6y3w35z2qz" />
          </div>
          <div className="mt-4" data-id="element-150" data-mp="36qzptwnapf5v">
            <ScarcityBar data-id="element-151" data-mp="1hbigtn9gmo3f" />
          </div>
        </div>
      </div>
    </section>;
}